<template>
<div class="p-tabmenu p-component">
<ul class="p-tabmenu-nav p-reset" role="tablist">
<TabNavigationItem v-for="item in tabs" :data="item"></TabNavigationItem>
</ul>
</div>
</template>

<script>
export default {

  name: 'TabNavigation',
  props:["tabs"],
  data () {
    return {

    }
  },

};
</script>

<style lang="css" scoped>
</style>